const media =
[
    {
        headline: `Period trackers 'coercing' women into sharing risky information`,
        publisher: 'BBC News',
        url: 'https://www.bbc.co.uk/news/articles/cmj6j3d8xjjo'
    },

    {
        headline: "Privacy remains an issue with several women’s health apps",
        publisher: 'Science News',
        url: 'https://www.sciencenews.org/article/privacy-womens-health-apps-tracking'
    }
]

export default media;